var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"text-right list-view-button"},[_vm._t("action-button")],2),_c('v-card',{staticClass:"tab"},[_c('v-card-title',[_vm._t("tabs")],2),_c('div',{staticClass:"margin-20"},[_vm._t("tab-items")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }